<template>
    <WikiContainer class="flex w-full">
        <BonusesPromotions
            slot-scope="slotProps"
            :isLoading="slotProps.isLoading"
            :content="slotProps.content"
            class="flex w-full"
        />
    </WikiContainer>
</template>

<script>
    import WikiContainer from '@modules/wiki/WikiContainer.vue';
    import BonusesPromotions from '@modules/wiki/components/BonusesPromotions.vue';

    export default {
        name: 'PromotionsInfoPage',
        components: {
            WikiContainer,
            BonusesPromotions,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/pages/PromotionsInfoPage.vue